import { Api } from "laravel-request";

import type { ApiDataCallback } from "../types/legacyCallbacks";

export const getManagers = (callback: ApiDataCallback<any>) => {
    Api.get("employee", "index").all(({ data }: { data: any }) => {
        callback(data);
    });
};

export const getPermissions = (callback: ApiDataCallback<any>) => {
    Api.get("permission", "index").all(({ data }: { data: any }) => callback(data));
};

export const getUserPermissions = (callback: ApiDataCallback<any>) => {
    Api.get("permission-user", "index").all(({ data }: { data: any }) => callback(data));
};
